import 'focus-visible';
import './blocks-ui/info-block/info-block';

import './blocks-content/header/header';
import './blocks-content/footer/footer';
import './blocks-content/page-head/page-head';
import './blocks-content/push-example/push-example';
import './blocks-content/push-about/push-about';
import './blocks-content/presubscribe-form/presubscribe-form';
import './blocks-content/clients/clients';
import './blocks-content/modal-support/modal-support';
import './blocks-content/modal-subscribe/modal-subscribe';
import './blocks-content/push-tariff/push-tariff';
